import styled from '@emotion/styled'

import { breakpoints, palette, spacing } from 'main/ui'

export const Container = styled.div`
  height: 100%;
`

export const Clickable = styled.div`
  cursor: pointer;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const PhotoContainer = styled.div`
  position: relative;
  max-width: ${breakpoints.sm}px;
  max-height: ${(breakpoints.sm / 16) * 9}px;
`

export const UpcomingEventContainer = styled.div`
  left: ${spacing.majorScale(1)}px;
  position: absolute;
  top: ${spacing.majorScale(1)}px;
`

export const BookmarkContainer = styled.div`
  position: absolute;
  top: ${spacing.majorScale(2)}px;
  right: ${spacing.majorScale(2)}px;
`

export const SchoolNameContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const SubInfoContainer = styled.div`
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const StyledPhilosophyTag = styled.div`
  position: absolute;
  bottom: 0;
  background-color: ${palette.white};
  padding-right: ${spacing.minorScale(1)}px;
`
